import { ENV_ELASTIC_INDEX_SEARCH } from '../../components/Commons//Hooks/Variables/Enviroment';
export const Country = {
	CL: {
		handleElasticPrecision: () => {
			return ENV_ELASTIC_INDEX_SEARCH;
		},
		handleFilters: (params) => {
			let filters = [];
			filters.push({
				field: 'laboratory',
				values: [capitalizeFirstLetter(params.laboratory)],
			});
			filters.push({
				field: 'min_price',
				values: [0],
				type: 'none',
			});
			return filters;
		},
		handleSort: () => {
			let sort = [
				{
					available: 'desc',
				},
				{
					validate_recipe: 'asc',
				},
			];
			return sort;
		},
	},
		CLNARMA: {
		handleElasticPrecision: () => {
			return ENV_ELASTIC_INDEX_SEARCH;
		},
		handleFilters: (params) => {
			let filters = [];
			filters.push({
				field: 'laboratory',
				values: [capitalizeFirstLetter(params.laboratory)],
			});
			filters.push({
				field: 'min_price',
				values: [0],
				type: 'none',
			});
			return filters;
		},
		handleSort: () => {
			let sort = [
				{
					available: 'desc',
				},
				{
					validate_recipe: 'asc',
				},
			];
			return sort;
		},
	},

		CLGREEN: {
		handleElasticPrecision: () => {
			return ENV_ELASTIC_INDEX_SEARCH;
		},
		handleFilters: (params) => {
			let filters = [];
			filters.push({
				field: 'laboratory',
				values: [capitalizeFirstLetter(params.laboratory)],
			});
			filters.push({
				field: 'min_price',
				values: [0],
				type: 'none',
			});
			return filters;
		},
		handleSort: () => {
			let sort = [
				{
					available: 'desc',
				},
				{
					validate_recipe: 'asc',
				},
			];
			return sort;
		},
	},
	CLANICX: {
		handleElasticPrecision: () => {
			return ENV_ELASTIC_INDEX_SEARCH;
		},
		handleFilters: (params) => {
			let filters = [];
			filters.push({
				field: 'laboratory',
				values: [capitalizeFirstLetter(params.laboratory)],
			});
			filters.push({
				field: 'min_price',
				values: [0],
				type: 'none',
			});
			return filters;
		},
		handleSort: () => {
			let sort = [
				{
					available: 'desc',
				},
				{
					validate_recipe: 'asc',
				},
			];
			return sort;
		},
	},
	AR: {
		handleElasticPrecision: () => {
			return ENV_ELASTIC_INDEX_SEARCH;
		},
		handleFilters: (params) => {
			let filters = [];
			filters.push({
				field: 'laboratory',
				values: [capitalizeFirstLetter(params.laboratory)],
			});
			filters.push({
				field: 'min_price',
				values: [0],
				type: 'none',
			});
			return filters;
		},
		handleSort: () => {
			let sort = [
				{
					stock: 'desc',
				},
				{
					validate_recipe: 'asc',
				},
			];
			return sort;
		},
	},
};

const capitalizeFirstLetter = (item) => {
	return item.charAt(0).toUpperCase() + item.slice(1);
};
Country.CLZUPHARMA = Country.CLGREEN;
